module.exports = __webpack_public_path__ + "img/bg_login.d1d2d664.png";